import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/Tooltip.tsx';
import { EnumValueConfig } from '@/components/table/_fieldDefinitions/enum/EnumTableConfig.ts';
import { StatusDot } from '@/components/ui/StatusDot.tsx';

/**
 * Wartość enuma w komórce tabeli — wspólna dla rejestru enumów i dla statusu
 * wiadomości, który składa swój config sam, ale wygląda tak samo.
 */
export const EnumValueCell = ({ config }: { config: EnumValueConfig }) => {
  const displayMode = config.displayMode ?? 'text';
  const showIcon = displayMode === 'icon' || displayMode === 'text+icon';

  const content = (
    <StatusDot
      label={config.label}
      color={config.color}
      iconColor={config.iconColor}
      attentionColor={config.textColor}
      icon={showIcon ? config.icon : undefined}
      showLabel={displayMode !== 'icon'}
    />
  );

  if (!config.tooltip) return content;

  return (
    <Tooltip>
      {/* StatusDot nie przekazuje dalej refa, więc `asChild` potrzebuje własnego elementu. */}
      <TooltipTrigger asChild>
        <span className="inline-flex max-w-full cursor-default">{content}</span>
      </TooltipTrigger>
      <TooltipContent>{config.tooltip}</TooltipContent>
    </Tooltip>
  );
};
